import { SetDataLayerParamsUseCase } from '@/core/domain/gtm/usecases/setDataLayer.usecase';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { GtmImplRepository } from './gtm-impl.repository';
import { GtmRepository } from '@/core/domain/gtm/repositories/gtm.repository';
import { GtmReserveSearchUseCase } from '@/core/domain/gtm/usecases/gtmReserveSearch.usecase';
import { GtmViewItemListUseCase } from '@/core/domain/gtm/usecases/gtmViewItemList.usecase';
import { GtmSelectItemUseCase } from '@/core/domain/gtm/usecases/gtmSelectItem.usecase';
import { GtmAddToCartUseCase } from '@/core/domain/gtm/usecases/gtmAddToCart.usecase';
import { GtmBeginCheckoutUseCase } from '@/core/domain/gtm/usecases/gtmBeginCheckout.usecase';
import { GtmPurchaseUseCase } from '@/core/domain/gtm/usecases/gtmPurchase.usecase';
import { environment } from '@/env/environment';
import { GtmRefundUseCase } from '@/core/domain/gtm/usecases/gtmRefund.usecase';
import { GtmSelectCartUseCase } from '@/core/domain/gtm/usecases/gtmSelectCar.usecase';
import { GtmSelectExtrasUseCase } from '../../core/domain/gtm/usecases/gtmSelectExtras.usecase';
import { GtmReservationCompleteUseCase } from '@/core/domain/gtm/usecases/gtmReservationComplete.usecase';

const gtmLoaderUseCaseFactory = (gtmRepository: GtmRepository) =>
    new SetDataLayerParamsUseCase(gtmRepository);

const reserveSearchUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmReserveSearchUseCase(gtmRepository);

const gtmViewItemListUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmViewItemListUseCase(gtmRepository);

const gtmSelectItemUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmSelectItemUseCase(gtmRepository);

const gtmAddToCartUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmAddToCartUseCase(gtmRepository);

const gtmBeginCheckoutUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmBeginCheckoutUseCase(gtmRepository);

const gtmPurchaseUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmPurchaseUseCase(gtmRepository);

const gtmRefundUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmRefundUseCase(gtmRepository);

const gtmSelectCartUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmSelectCartUseCase(gtmRepository);

const GtmSelectExtrasUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmSelectExtrasUseCase(gtmRepository);

const GtmReservationCompleteUseCaseFactory = (gtmRepository: GtmRepository) =>
    new GtmReservationCompleteUseCase(gtmRepository);

@NgModule({
    imports: [
        CommonModule,
        GoogleTagManagerModule.forRoot({
            id: environment.googleTagManager.id,
        }),
    ],
    providers: [
        {
            provide: GtmRefundUseCase,
            useFactory: gtmRefundUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmPurchaseUseCase,
            useFactory: gtmPurchaseUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmBeginCheckoutUseCase,
            useFactory: gtmBeginCheckoutUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmAddToCartUseCase,
            useFactory: gtmAddToCartUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmSelectItemUseCase,
            useFactory: gtmSelectItemUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmViewItemListUseCase,
            useFactory: gtmViewItemListUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmReserveSearchUseCase,
            useFactory: reserveSearchUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: SetDataLayerParamsUseCase,
            useFactory: gtmLoaderUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmSelectCartUseCase,
            useFactory: gtmSelectCartUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmSelectExtrasUseCase,
            useFactory: GtmSelectExtrasUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmReservationCompleteUseCase,
            useFactory: GtmReservationCompleteUseCaseFactory,
            deps: [GtmImplRepository],
        },
        {
            provide: GtmRepository,
            useClass: GtmImplRepository,
        },
    ],
})
export class GtmDataModule {}
